import React from 'react';
const links = ['AGB', 'Datenschutz', 'Rückerstattung', 'Kontakt'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-92" data-mp="3gfiswe27a3c0">
      <div className="mx-auto max-w-5xl text-center" data-id="element-93" data-mp="3gh3q6bfwg0dk">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-94" data-mp="32ovvcp86ejhi">
          YOGA BEREIT™
        </p>
        <nav aria-label="Footer" data-id="element-95" data-mp="36ppktn19o6ci">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-96" data-mp="3uf0lz5mj42r6">
            {links.map(link => <li key={link} data-id="element-97" data-mp="37xxwn1zmcl6">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-98" data-mp="3lecb2jsfmiii">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-99" data-mp="29zgl41oc4umn">
          © 2026 YOGA BEREIT™. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}